import {
  Box,
  Paper,
  Typography,
} from "@material-ui/core";
import KVMViewer from "modus/components/misc/KVMViewer";

import React from "react";
import GenericPageTitle from "modus/components/generic-page-title/GenericPageTitle";
import SpikeArrestConfigForm from "./SpikeArrestConfigForm";
import SubscriptionQuota from "./SubscriptionQuotaForm";

interface IAPIThrottling {
  deployStatus: string;
  spikeArrestEnabled: boolean;
  spikeArrestLimit: number  ;
  spikeArrestTimeunit: string;
  subscriptionQuotaEnabled: boolean;
  subscriptionQuotaLimit: number;
  subscriptionQuotaInterval: number;
  subscriptionQuotaTimeunit: string;
}
interface ThrottlingDetailsProps {
  deploymentId: string;
  deployStatus?: string;
  refreshDeploymentList: () => void;
  apiThrottling?: IAPIThrottling | null ;
  serviceId: string;
}


  export type TimeUnit = {
    key: string;
    value: string;
  };

  const availableSpikeArrestTimeUnit: readonly TimeUnit[] = [
    { key: "per Second", value: "SECOND" },
    { key: "per Minute", value: "MINUTE" },
  ] as const;

  const availableQuotaArrestTimeUnit: readonly TimeUnit[] = [
    { key: "per Hour", value: "HOUR" },
    { key: "per Day", value: "DAY" },
    { key: "per Week", value: "WEEK" },
    { key: "per Month", value: "MONTH" },
    { key: "per Minute", value: "MINUTE" },
  ] as const;


export const ThrottlingDetails: React.FC<ThrottlingDetailsProps> = React.memo((props) => {




  return (
    <Paper style={{ width: "100%" }}>
      <Box padding={"20px"}>
        <GenericPageTitle
          noSkeleton
          title={
            <Typography variant="body1" style={{ fontWeight: 600 }}>
              Throttling Features
            </Typography>
          }
        ></GenericPageTitle>
        <KVMViewer
          dataList={{
            "Spike Arrest": (
              <Box
                display={"flex"}
                alignItems="center"
                justifyContent="space-between"
              >
                <Typography>{props?.apiThrottling!=null && props?.apiThrottling?.spikeArrestLimit!==0 ? `${props?.apiThrottling?.spikeArrestLimit} hits / ${props?.apiThrottling?.spikeArrestTimeunit?.toLowerCase()}`: "No Limit"}</Typography>
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="flex-end"
                >
                  <SpikeArrestConfigForm
                    SubscriptionQuotaConfig={props?.apiThrottling ? {
                      enabled: props?.apiThrottling?.subscriptionQuotaEnabled,
                      limit: props?.apiThrottling?.subscriptionQuotaLimit,
                      interval: props?.apiThrottling?.subscriptionQuotaInterval,
                      unit: props?.apiThrottling?.subscriptionQuotaTimeunit,
                    } : null}
                    spikeArrestConfig={props?.apiThrottling ? {
                      enabled: props?.apiThrottling?.spikeArrestEnabled,
                      limit:  props?.apiThrottling?.spikeArrestLimit ,
                      unit: props?.apiThrottling?.spikeArrestTimeunit,
                    } : null
                  }
                    deploymentStatus={props?.deployStatus || null}
                    onSuccess={props?.refreshDeploymentList}
                    deploymentId={props?.deploymentId}
                    availableTimeUnit={availableSpikeArrestTimeUnit}
                    spikeArrestEnabled={props?.apiThrottling?.spikeArrestEnabled ?? false }
                    serviceId={props?.serviceId}
                  ></SpikeArrestConfigForm>

                </Box>
              </Box>
            ),
            "Subscription Quota": (
              <Box
                display={"flex"}
                alignItems="center"
                justifyContent="space-between"
              >
                <Typography>{props?.apiThrottling!=null && props?.apiThrottling?.subscriptionQuotaLimit!==0 ? `${props?.apiThrottling?.subscriptionQuotaLimit} hits per ${props?.apiThrottling?.subscriptionQuotaInterval} ${props?.apiThrottling?.subscriptionQuotaTimeunit?.toLowerCase()}` : "No Limit"}</Typography>
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="flex-end"
                >
                  <SubscriptionQuota
                    SubscriptionQuotaConfig={props?.apiThrottling ? {
                      enabled: props?.apiThrottling?.subscriptionQuotaEnabled,
                      limit: props?.apiThrottling?.subscriptionQuotaLimit,
                      interval: props?.apiThrottling?.subscriptionQuotaInterval,
                      unit: props?.apiThrottling?.subscriptionQuotaTimeunit,
                    } : null}
                    spikeArrestConfig={props?.apiThrottling ? {
                      enabled: props?.apiThrottling?.spikeArrestEnabled,
                      limit:  props?.apiThrottling?.spikeArrestLimit ,
                      unit: props?.apiThrottling?.spikeArrestTimeunit,
                    } : null
                  }
                    deploymentStatus={props?.deployStatus || null}
                    serviceId={props?.serviceId}
                    subscriptionQuotaEabled={props?.apiThrottling?.subscriptionQuotaEnabled ?? false }
                    onSuccess={props?.refreshDeploymentList}
                    availableTimeUnit={availableQuotaArrestTimeUnit}
                    deploymentId={props.deploymentId}
                  ></SubscriptionQuota>

                </Box>
              </Box>
            ),
          }}
        />
      </Box>
    </Paper>
  );
});